<su-headline h="h1" skin="primary">{{ title }}</su-headline>

<su-slot-tabs [tabs]="tabs" [activeTab]="activeTab"></su-slot-tabs>

<su-slot-tab-content *ngIf="activeTab === tabs[0].id">
  <div
    class="task-card-shell"
    [class.task-card-shell--wide]="isWideLayout"
    data-mode="light">
    <div class="top-button-container" *ngIf="isOPLExt">
      <su-button
        *ngIf="canShowOrderedAddendumQuotationButton"
        skin="primary"
        [label]="
          'taskmodule.task.offer.ordered_addendum_offer.button_label'
            | translate
        "
        (onClick)="showOrderedAddendumQuotation()"
        [tooltip]="
          'taskmodule.task.offer.tooltip.ordered_addendum_offer' | translate
        ">
      </su-button>
      <su-button
        *ngIf="isTask7ExecuteOptionalService"
        skin="primary"
        [label]="'taskmodule.task.offer.ordered_offer.button_label' | translate"
        (onClick)="showOrderedQuotation()"
        [tooltip]="'taskmodule.task.offer.tooltip.ordered_offer' | translate">
      </su-button>
      <su-button
        skin="secondary"
        icon="file-excel"
        [label]="'Excel Download'"
        (onClick)="exportToExcel()"
        [disabled]="!canDownload">
      </su-button>
    </div>

    <su-card [card]="cardFields">
      <div card-content>
        <div class="card-action-row" *ngIf="isOPLExt">
          <span
            *ngIf="isTask2_3_7_11 && taskSubjectHeadline"
            class="task-subject-headline">
            {{ taskSubjectHeadline }}
          </span>

          <div class="card-action-controls">
            <su-button
              skin="secondary"
              icon="arrows-left-right"
              [matTooltip]="buttonMaxWidthTitle"
              [ariaLabel]="buttonMaxWidthTitle"
              (onClick)="toggleWideLayout()"></su-button>
          </div>
        </div>

        <formly-form
          [form]="form"
          [fields]="formFields"
          [model]="formModel"></formly-form>

        <ng-container *ngIf="isTask11SubmitInvoiceToScanCenter">
          <formly-information-row />
        </ng-container>

        <app-detail-fields-base
          *ngIf="task"
          [data]="task"
          [detailFields]="detailFields"
          [allowFileUpload]="
            !isTask11SubmitInvoiceToScanCenter
          "></app-detail-fields-base>
      </div>
    </su-card>
  </div>
</su-slot-tab-content>

<su-slot-tab-content *ngIf="activeTab === tabs[1].id">
  <su-card [card]="cardContact">
    <div card-content>
      <app-task-contact
        *ngIf="task"
        [isOPLExt]="isOPLExt"
        [dataContactAddress]="dataContactAddress"></app-task-contact>
    </div>
  </su-card>
</su-slot-tab-content>

<su-slot-tab-content *ngIf="activeTab === tabs[2]?.id">
  <div [style]="descriptionContainerStyle">
    <div
      class="sub-headline contactDescription"
      [style]="descriptionStyle"
      [innerHtml]="description | safeHtml"></div>
  </div>
  <su-card [card]="cardContactUs">
    <div card-content>
      <form [formGroup]="formContactUs">
        <formly-form
          [form]="formContactUs"
          [fields]="formFieldsContactUs"
          [model]="formModelContactUs"></formly-form>
        <app-spinner-overlay
          [show]="isLoading"
          [label]="
            'ticket.summary.contact.loading_message' | translate
          "></app-spinner-overlay>
      </form>
    </div>
  </su-card>
</su-slot-tab-content>
<app-spinner-overlay [show]="isLoading"></app-spinner-overlay>
